export function PricingDisclaimer() {
  return (
    <div className="text-fluid-base-sm text-fg-muted">
      <p>
        All pricing data is delayed and reflects the previous trading day's
        close. For real-time data, please check current market feeds.
      </p>
    </div>
  );
}
